import tpl from './maintenance-placeholder.tpl.html';
import './maintenance-placeholder.component.scss';

/**
 * Placeholder component that will be shown in case maintenance is active and an element cannot be used.
 */
class MaintenancePlaceholderComponent {
  constructor(gettextCatalog) {
    'ngInject';

    /**
     * Name of the element that is disabled, used in the text.
     * @type {string}
     */
    /// Oletussana sille mikä osa sivustoa ei ole käytettävissä, esim: "Toiminto ei ole valitettavasti käytössä huoltotilan aikana.". Korvautuu esim. "ajanvaraus"
    this.elementName = gettextCatalog.getString('toiminto');
  }
}

const config = {
  templateUrl: tpl,
  controller: MaintenancePlaceholderComponent,
  bindings: {
    elementName: '@?'
  }
};

const mod = angular.module('app.common.keepalive.maintenancePlaceholder', [])

.component('maintenancePlaceholder', config);

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/keepalive/maintenance-placeholder.component.js